import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Customer from '@/views/Customer.vue'
import CustomerByEmail from '@/views/CustomerByEmail.vue'
import CancelOrderByEmail from '@/views/zdesk/CancelOrderByEmail.vue'
import CancelSubscriptionByEmail from '@/views/zdesk/CancelSubscriptionByEmail.vue'
import GotoLatestOrderByEmail from '@/views/zdesk/GotoLatestOrderByEmail.vue'
import Order from '@/views/Order.vue'
import ReturnOrders from '@/views/ReturnOrders.vue'
import BankPayments from '@/views/BankPayments.vue'
import BatchOperateOrders from '@/views/BatchOperateOrders.vue'
import Orders from '@/views/Orders.vue'
import OrderDiagnostics from '@/views/OrderDiagnostics.vue'
import CreateProduct from '@/views/CreateProduct'
import ProductStyles from '@/views/ProductStyles'
import ProductBulkUpdate from '@/views/ProductBulkUpdate'
import ProductTroubleshoot from '@/views/ProductTroubleshoot.vue'
import Translations from '@/views/Translations.vue'
import PaymentIntent from '@/views/PaymentIntent.vue'
import StatisticsSneakPeek from '@/views/statistics/SneakPeek.vue'
import StatisticsSneakPeekComplete from '@/views/statistics/SneakPeekComplete.vue'
import SubscriptionsStatisticsRenewals from '@/views/SubscriptionsStatisticsRenewals.vue'
import Subscription from '@/views/Subscription.vue'
import Login from '@/views/Login.vue'
import SizeConversionMismatch from '@/views/SizeConversionMismatch.vue'
import InventoryCache from '@/views/InventoryCache.vue'
import WarehouseProducts from '@/views/WarehouseProducts.vue'
import BalanceRequests from '@/views/BalanceRequests.vue'
import BalanceRefreshFailures from '@/views/BalanceRefreshFailures.vue'
import Dev from '@/views/Dev.vue'
import Tabs from '@/views/Tabs.vue'
import StylistOrders from '@/views/StylistOrders.vue'
import PurchaseOrders from '@/views/PurchaseOrders.vue'
import PurchaseOrder from '@/views/PurchaseOrder.vue'
import OrderShipping from '@/views/OrderShipping.vue'
import Campaigns from '@/views/Campaigns.vue'
import Stylists from '@/views/Stylists.vue'
import StylistPerformanceOverview from '@/views/StylistPerformanceOverview.vue'
import TypeGoals from '@/views/TypeGoals.vue'
import User from '@/views/User.vue'
import StylingProcess from '@/views/StylingProcess.vue'
import StylingModelCategories from '@/views/StylingModelCategories.vue'
import Email from '@/views/Email.vue'
import EmailTemplates from '@/views/EmailTemplates.vue'
import CreditCheck from '@/views/CreditCheck.vue'
import BlockedAddress from '@/views/BlockedAddress'
import BlockedPhone from '@/views/BlockedPhone.vue'
import QueuePush from '@/views/QueuePush.vue'
import Discounts from '@/views/Discounts.vue'
import EditDiscount from '@/views/EditDiscount.vue'
import LostShipments from '@/views/LostShipments.vue'
import OceanPackageReturns from '@/views/OceanPackageReturns.vue'
import DebtCollection from '@/views/DebtCollection.vue'
import Testing from '@/views/Testing.vue'
import TestingCronjobs from '@/views/TestingCronjobs.vue'
import TestingTemplates from '@/views/TestingTemplates.vue'
import CronjobPerformance from '@/views/CronjobPerformance.vue'
import ConductorJobs from '@/views/ConductorJobs.vue'
import ConductorJob from '@/views/ConductorJob.vue'
import VueSlideoutPanel from 'vue2-slideout-panel'
import MoveRenewals from '@/views/MoveRenewals.vue'
import Preshipping from '@/views/preshipping/Preshipping.vue'
import Pick2SPSchedule from '@/views/preshipping/Pick2SPSchedule.vue'
import DepositOverview from '@/views/deposit/DepositOverview.vue'
import BulkDiscount from '@/views/BulkDiscount.vue'
import BulkBankPayment from '@/views/BulkBankPayment.vue'

import store from './store.js'

Vue.use(VueSlideoutPanel)

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/testing',
      component: Testing
    },
    {
      path: '/bulk-discount',
      component: BulkDiscount
    },
    {
      path: '/bulk-bank-payment',
      component: BulkBankPayment
    },
    {
      path: '/pick2sp',
      component: Pick2SPSchedule
    },
    {
      path: '/testing-templates',
      component: TestingTemplates
    },
    {
      path: '/testing/cronjobs',
      component: TestingCronjobs
    },
    {
      path: '/cronjob-performance',
      component: CronjobPerformance
    },
    {
      path: '/conductor-jobs',
      component: ConductorJobs
    },
    {
      path: '/conductor-job/:id',
      component: ConductorJob
    },
    {
      path: '/move-renewals',
      component: MoveRenewals
    },
    {
      path: '/deposits',
      component: DepositOverview
    },
    {
      path: '/preshipping/:id',
      component: Preshipping
    },
    {
      path: '/campaigns',
      component: Campaigns
    },
    {
      path: '/discounts',
      component: Discounts
    },
    {
      path: '/discount/:id',
      component: EditDiscount
    },
    {
      path: '/debt-collection',
      component: DebtCollection
    },
    {
      path: '/email-templates',
      component: EmailTemplates
    },
    {
      path: '/users',
      component: Stylists
    },
    {
      path: '/user/:id',
      component: User
    },
    {
      path: '/email/:id',
      component: Email
    },
    {
      path: '/purchase-orders',
      component: PurchaseOrders
    },
    {
      path: '/order/:id/shipping',
      component: OrderShipping
    },
    {
      path: '/purchase-order/:id',
      component: PurchaseOrder
    },
    {
      path: '/stylings/tabs',
      component: Tabs
    },
    {
      path: '/stylist/orders',
      component: StylistOrders
    },
    {
      path: '/dev',
      component: Dev
    },
    {
      path: '/inventory-cache',
      component: InventoryCache
    },
    {
      path: '/warehouse-products',
      component: WarehouseProducts
    },
    {
      path: '/balance-requests',
      component: BalanceRequests
    },
    {
      path: '/order-balances/failures',
      component: BalanceRefreshFailures
    },
    {
      path: '/products/missing-size-conversions',
      component: SizeConversionMismatch
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/stylist/performance-overview',
      component: StylistPerformanceOverview
    },
    {
      path: '/stylings/process',
      component: StylingProcess
    },
    {
      path: '/stylings/edit-letter',
      components: require('./components/styling-process/EditLetter.vue')
    },
    {
      path: '/stylings/prev-orders',
      components: require('./components/styling-process/PrevOrders.vue')
    },
    {
      path: '/subscriptions/statistics/sneak-peek',
      component: StatisticsSneakPeek
    },
    {
      path: '/subscriptions/statistics/sneak-peek-complete',
      component: StatisticsSneakPeekComplete
    },
    {
      path: '/subscriptions/statistics/renewals',
      component: SubscriptionsStatisticsRenewals
    },
    {
      path: '/orders',
      component: Orders
    },
    {
      path: '/subscription/:id',
      component: Subscription
    },
    {
      path: '/payment-intent/:id',
      component: PaymentIntent
    },
    {
      path: '/translations',
      component: Translations
    },
    {
      path: '/return-orders',
      component: ReturnOrders
    },
    {
      path: '/products/create',
      component: CreateProduct
    },
    {
      path: '/products/bulk-update',
      component: ProductBulkUpdate
    },
    {
      path: '/products/troubleshoot',
      component: ProductTroubleshoot
    },
    {
      path: '/products/styles',
      component: ProductStyles
    },
    {
      path: '/product/:id',
      component: CreateProduct
    },
    {
      path: '/order/:id/diagnostics',
      component: OrderDiagnostics
    },
    {
      path: '/customer/:id',
      component: Customer
    },
    {
       path: '/zdesk/cancel_order/:email',
       component: CancelOrderByEmail
    },
    {
       path: '/zdesk/cancel_order_and_sub/:email',
       component: CancelOrderByEmail
    },
    {
       path: '/zdesk/cancel_sub_only/:email',
       component: CancelSubscriptionByEmail
    },
    {
        path: '/zdesk/goto_latest/:email',
        component: GotoLatestOrderByEmail
     },
    {
      path: '/customer/email/:email',
      component: CustomerByEmail
    },
    {
      path: '/order/:id',
      component: Order
    },
    {
      path: '/bank-payments',
      component: BankPayments
    },
    {
      path: '/orders-batch-operation',
      component: BatchOperateOrders
    },
    {
      path: '/set-goals',
      component: TypeGoals
    },
    {
      path: '/styling-model-categories',
      component: StylingModelCategories
    },
    {
      path: '/credit/check',
      component: CreditCheck
    },
    {
      path: '/blocked/address',
      component: BlockedAddress
    },
    {
      path: '/blocked/phone',
      component: BlockedPhone
    },
    {
      path: '/queue/push',
      component: QueuePush
    },
    {
      path: '/lost-shipments',
      component: LostShipments
    },
    {
      path: '/ocean-package-returns',
      component: OceanPackageReturns
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (
    to.meta.requireAdminAuth !== undefined &&
    to.meta.requireAdminAuth &&
    !Vue.$user.hasRole('admin')
  ) {
    next({ name: 'home' })
  } else {
    next()
  }
})

export default router
